const Messages = {
  Success: {
    Saved: 'Saved',
    Rejected: 'Rejected',
    PasswordChanged: 'Password changed',
    ActivationSuccessful: 'Activation successful',
    CheckYourEmailToCompleteReg: 'Check your email to complete registration',
    Copied: 'Filter successfully copied',
    NotCopiedFilterNotSet: 'Not copied. Filter is missing',
    DocumentsPassed: 'Pass state has been set',
    DocumentsUnpassed: 'Pass state has been unset',
  },

  Errors: {
    PageSize: '`pageSize` must be positive integer more than zero',
    ErrorWhileRequest: 'An error occurred while retrieving data. {0}',
    ErrorWhileRequestTotal: 'An error occurred while retrieving the total row data. {0}',
    FormNotFound: 'Form {0} not found',
    UnsupportedFieldType: 'Unsupported field type - {0}',
    FieldIsRequired: '{0} is required',
    FieldsAreRequired: 'Fields are required: {0}',
    FilterNotSet: 'Filter is missing',
    FilteringRulesError: 'Filtering rules are not defined!',
    CopingRulesError: 'Coping rules are not defined!',
    LoginValidMsg: 'Should not be empty or contain any whitespaces.',
    PassValidMsg: 'Should not be empty and contain less then 6 symbols.',
    RecordNotFound: 'Records not found.',
    EmailIsRequired: 'Field email is required',
    PassAndConfirmDifferent: 'Password and confirmation are not identical',
    PassAndConfirmRequired: 'Password and confirmation are required',
    PassRequired: 'Password is required',
    ConfirmRequired: 'Password confirmation is required',
    ResponseEmpty: 'Response is empty.',
    CustomFontsLoadingError: 'Failed to load custom fonts',
    AtLeastOneRowMustBeSelected: 'At least one row must be selected',
    FilteringRulesAreNotDefined: 'Filtering rules are not defined',
    OnlyOneSelectedRowAllowedForThisAction:
      'Destination field is not multiselect. Only one selected row allowed for this action',
    ListFormAndTreeViewSubFormsTypes:
      'Only sub forms with types ListForm, TreeView, EditForm and FreeForm are allowed for form with types ListForm and TreeView',
    EditFormAndFreeFormSubFormsTypes:
      'Only sub forms with types ListForm, TreeView, EditForm and FreeForm are allowed for form with types EditForm and FreeForm',
    ReportFormAndMultiEditFormSubFormsTypes:
      'Subforms for forms with types ReportForm and GroupEditForm are not allowed',
    EmptyRespInGetEditFormDataFunc: 'Empty response in getEditFormData function',
    RequiredFiltersEmpty: 'Required filters are not filled',
    FiltersAreRequired: 'Filters are required: {0}',
    SmallPassword: 'Your password should be more than {0} symbols',
    IsEmptyBodyFilter: 'You are trying to save empty filter',
    IsRequired: 'is not filled',
    AreRequired: 'are not filled',
    SpacesError: 'can not contain spaces',
    IsIncorrect: 'is incorrect',
    ErrorSymbols: 'Unacceptable symbols in {0} field',
    NoFormAttached: 'No form attached for this operation',
    InvalidDate: 'Invalid date',
    DateToMustBeLess: 'Date to must be less than Date From',
    WhileDeletingRow: 'Error occurred while deleting rows',
    AtLeastOneTabMustBeVisible: 'At least one tab must be visible',
    AtLeastOneButtonMustBeVisibleInToolbar: 'At least one button must be visible in toolbar',
    AtLeastOneButtonMustBeVisibleInMenu: 'At least one button must be visible in menu',
    AtLeastOneColumnMustBeVisible: 'At least one column must be visible',
    AtLeastOneBoardMustBeVisible: 'At least one board must be visible',
    InvalidDateEntered: 'Invalid date entered.',
    ErrorOccurred: 'An error has occurred',
    InvalidFilter: 'Saved filter is invalid. Please, recreate it.',
    ClientScriptInitializationError: 'Client script initialization error',
    ParentFormError: 'Can be invoked only on the parent form, but not subform.',
    GroupDoesNotExist: 'Current group {0} does not exist',
    ButtonDoesNotExist: 'Button {0} does not exist',
  },

  Warning: {
    ChangeFilterInUserScript:
      'In the user defined scripts it is not allowed ' +
      'to change the filter while the table is in edit mode. The filter have not been applied.',
    CustomParamByFN: 'The field `{0}`, which is specified in `CustomParameters`, cannot be found on the form.',
    EditNestedDataOnlyInInlineMode: 'Editing of a nested object is allowed only in row mode.',
    OnSaveRowDeprecated: 'Method `onSaveRow` is deprecated, use `onRowBeforeSave` instead.',
    OnInitializedDeprecated: 'Method `onInitialized` is deprecated, use `onBeforeEditRow` instead.',
    OnMasterSelectFilterDeprecated: 'Method `OnMasterSelectFilter` is deprecated, use `onMasterSelectFilter` instead.',
    OnBeforeGetDataFilterDeprecated: 'Method `OnBeforeGetData` is deprecated, use `onBeforeGetData` instead.',
    AllColumnsDisabledForReordering: 'All columns are not available for reordering.',
    LoadAllWarningMessage: 'The first `{0}` lines are displayed. Refine the data selection condition',
    FormWithoutElements: 'It`s impossible to open a form without elements',
  },

  Confirm: {
    RowsDelete: 'Delete selected records?',
    SaveChanges: 'Save modifications?',
    ResetAllSettings: 'Are you sure you want to reset all settings?',
    ClearQuickFilters: 'Do you want to clear all applied filter?',
    SetIsPassed: 'Do you want to set is passed?',
    ClearIsPassed: 'Do you want to clear is passed?',
    ChangeFilter: 'Are you sure you want to change filter?',
    ChangeFavorite: 'Are you sure you want to change favorite state?',
    DeleteFilter: 'Are you sure you want to delete saved filter',
  },

  Message: {
    EnterLoginAndPass: 'Enter login and password',
    Deleted: 'Deleted',
    SingIn: 'Sign In to your account',
    CheckYourEmail: 'Check your email to complete password restore',
    EnterFilterName: 'Enter filter name here',
    Count: 'QUANTITY',
    Avg: 'AVERAGE',
    Sum: 'SUM',
    Min: 'MINIMAL',
    Max: 'MAXIMUM',
    FilterAddedToFavorite: 'Filter set as "Favorite"',
    FilterRemovedFromFavorite: 'Filter removed from "Favorite"',
    FilterSetAsDefault: 'Filter set as "Default"',
    FilterSetAsRegular: 'Filter no more set as "Default"',
    FilterChanged: 'Filter changed',
    FilterRemoved: 'Filter removed',
    FilterNameChanged: 'Filter name changed',
    WeCanNotFindPage: "We can't seem to find the page you're looking for.",
    SomethingWentWrong: 'Something went wrong!',
    HereHelpfulLinks: 'Here are some helpful links instead:',
    ErrorCode404: 'Error code: 404',
    Help: 'Help',
    UserSettings: 'User settings',
    Notifications: 'Notifications',
    Profile: 'Profile',
  },

  Controls: {
    Home: 'Home',
    SingIn: 'Sign In',
    SingUp: 'Sign Up',
    SingOut: 'Sign out',
    Login: 'Login',
    ForgotPassword: 'Forgot your password?',
    Name: 'Name',
    Email: 'Email',
    Password: 'Password',
    Cancel: 'Cancel',
    Close: 'Close',
    Clear: 'Clear',
    OK: 'OK',
    Yes: 'Yes',
    No: 'No',
    All: 'All',
    On: 'On',
    Off: 'Off',
    OR: 'or',
    Confirmation: 'Confirmation',
    Select: 'Select',
    SelectAll: 'Select all',
    SelectValue: 'Select a value',
    SelectAllHint: 'Select All records',
    ShowTableFilterRow: 'Show/hide filter record',
    UserSettings: 'User settings',
    GeneralSettings: 'General settings',
    TablesTreesSettings: 'Tables and trees settings',
    EditorStylingMode: 'Editor Styling Mode',
    Filter: 'Filter',
    FilterManager: 'Filter manager',
    CopyFilterAsURL: 'Copy filter as URL',
    ChangeFilter: 'Change filter',
    LoadAll: 'Load all',
    Report: 'Report',
    ReportGroup: 'Report group',
    DeselectAll: 'Deselect all',
    DeselectAllHint: 'Deselect all records',
    LoadingPanel: 'Loading...',
    SaveAndClose: 'Save & Close',
    Apply: 'Apply',
    RegionalSettings: 'Regional settings',
    CommonSettings: 'Common settings',
    ResetAllSettings: 'Reset all settings',
    ColumnChooser: 'Column chooser',
    Settings: 'Settings',
    CalcTotals: 'Summary row',
    CalcTotalsNone: 'Disabled',
    CalcTotalsNoneHint: 'Calculating the summary row is disabled',
    CalcTotalsBySelected: 'By selected',
    CalcTotalsBySelectedHint: 'Calculate the summary row for the selected rows in the table',
    CalcTotalsAllData: 'All data',
    TabSettings: 'Tabs settings',
    ResetAllSettingsHint: 'Reset all user settings',
    SelectCamera: 'Select a camera',
    Add: 'Add',
    Edit: 'Edit',
    View: 'View',
    Delete: 'Delete',
    Copy: 'Copy',
    Refresh: 'Refresh',
    IsBlank: 'Is blank',
    IsNotBlank: 'Is not blank',
    IsAnyOf: 'Is any of',
    IsNotAnyOf: 'Is not any of',
    Preferences: 'Preferences',
    Rename: 'Rename',
    Export: 'Export',
    ExportAll: 'Export all data',
    ExportSelected: 'Export selected rows',
    SaveWithOutClose: 'Save',
    Save: 'Save',
    Discard: 'Discard',
    Send: 'Send',
    SendRequest: 'Send Request',
    ApplicationLanguage: 'Application language',
    Appearance: 'Appearance',
    ApplicationTheme: 'Application theme',
    DrawerTheme: 'Navigation panel theme',
    SystemToolbarTheme: 'System toolbar theme',
    ApplicationDrawerSide: 'Menu location',
    DrawerSideLeft: 'Left',
    DrawerSideRight: 'Right',
    Format: 'Format',
    ClearQuickFilters: 'Clear all applied filter',
    ClearAll: 'Clear all',
    RememberMe: 'Remember me',
    SetIsPassed: 'Set is passed',
    ClearIsPassed: 'Clear is passed',
    AddChild: 'Add Child',
    ShowMore: 'Show more',
    ShowTitle: 'Show title',
    More: 'More',
    OpenInNewTab: 'Open in a new tab',
    Open: 'Open',
    CopyText: 'Copy text',
    Blank: '(Blanks)',
    Today: 'Today',
    StartWork: 'Start work',
    CreateProject: 'Create project',
    Orders: 'Orders',
    Groups: 'Groups',
    CreateList: 'Create list',
    Filters: 'Filters',
    EditFilters: 'Edit filters',
    Documentation: 'Documentation',
    ProfileSettings: 'Profile settings',
    Toolbar: 'Toolbar',
    Menu: 'Menu',
    GoBack: 'Go back',
    GoToMenu: 'Back to menu',
    HideColumn: 'Hide column',
    UnfixColumns: 'Unfix columns',
    SortAscending: 'Sort ascending',
    SortDescending: 'Sort descending',
    ClearSorting: 'Clear sorting',
    ClearFiltering: 'Clear filter',
    Unfix: 'Unfix',
    FixColumnsToTheLeft: 'Fix columns to the left',
    FixToTheLeft: 'Fix to the left',
    FixToTheRight: 'Fix to the right',
    Value: 'Value',
    Values: 'Values',
    DefaultFilter: 'Default filter',
    Favorite: 'Favorite',
    ModifyDate: 'Modify date',
    NewFilter: 'New filter',
    ShowFilterDockPanel: 'Show filter dock panel',
    ShowEditDockPanel: 'Show edit dock panel',
    CustomizeFields: 'Customize fields',
    ShowFields: 'Show Fields',
    Default: 'Default',
    SavedFilters: 'Saved filters',
    SmallRowSize: 'Small',
    MediumRowSize: 'Medium',
    LargeRowSize: 'Large',
    RowSizes: 'Row sizes',
    Columns: 'Columns',
    Tabs: 'Tabs',
    Buttons: 'Buttons',
    Other: 'Other',
    Search: 'Search',
    Sections: 'Sections',
    Favorites: 'Favorites',
    EmptyListText: 'Favorite filters absent',
    InterfaceSize: 'Interface size',
    Language: 'Language',
    Contains: 'Мatch search',
    StartsWith: 'Search by first characters',
    ByWords: 'Search by words',
    Help: 'Help',
    Details: 'More',
    Equals: 'Equals',
    DoesNotEquals: 'Does not equals',
    LessThan: 'Less than',
    GreaterThan: 'Greater than',
    LessOrEqualTo: 'Less than or equal to',
    GreaterOrEqualTo: 'Greater than or equal to',
    Between: 'Between',
    ContainsSmth: 'Contains',
    StartsWithSmth: 'Starts with',
    ByWordsSearch: 'By words',
    Boards: 'Boards',
    AllVisible: 'All visible',
    ClearValueMode: 'Clear value mode',
    HorizontalSeparatorLines: 'Horizontal separator lines',
    VerticalSeparatorLines: 'Vertical separator lines',
    AlternativeLinesColor: 'Alternative lines color',
    DefaultSt: 'Default',
    Show: 'Show',
    Hide: 'Hide',
    PreviewFile: 'Preview file',
  },
  AdditionalText: {
    YouDontHaveNotifications: "You don't have notifications",
    UnsavedChanges: 'You have unsaved changes! Do you want to save or discard these changes?',
    UseYourAccount: 'or use your account',
    EnterYourDetails: 'Enter your personal details and start journey with us',
    NewPassword: 'New password',
    ToKeepConnected: 'To keep connected with us please login with your personal info',
    WelcomeBack: 'Welcome Back!',
    CreateAccount: 'Create Account',
    RestorePassword: 'Restore password request',
    ByDefault: 'By default',
    InSubsystem: 'Show in subsystems',
    ModifyDate: 'Modify date',
    D5: 'D5',
    Insert: 'Insert',
    Edit: 'Edit',
    View: 'View',
    ResourceNotFound: 'Resource not found',
  },
};

export default Messages;
